// removed by extract-text-webpack-plugin
module.exports = {"scenarioCard":"scenarioCard___3whxg","header":"header___1iWA9","leverTitle":"leverTitle___i_YLo","sliderSectionHeading":"sliderSectionHeading___1Vac6","sliderTitle":"sliderTitle___1aFR6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/scenarioCard/styles.module.scss
// module id = 695
// module chunks = 0